import InvestmentHolding from './InvestmentHolding';

export default InvestmentHolding;
